export class StatusTextType {
  public static Approved = 'Approved';
  public static Rejected = 'Rejected';
  public static Pending = 'Pending';
  public static AdjournmentPending = 'Pending adjournment';
  public static AdjournmentRejected = 'Rejected adjournment';
  public static AdjournmentSineDiePending = StatusTextType.AdjournmentPending;
  public static DatePassed = 'Date passed';
  public static Upcoming = 'Upcoming';
  public static Adjourned = 'Adjourned';
  public static AdjouredSineDie = 'Adjoured sine die';
  public static Cancelled = 'Cancelled';
}
